export default __webpack_public_path__ + "static/media/forward.b231274e.svg";